// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("rescript/lib/js/list.js");
var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Belt_Int = require("rescript/lib/js/belt_Int.js");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Js_promise = require("rescript/lib/js/js_promise.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var Json_encode = require("@glennsl/bs-json/src/Json_encode.res.js");
var JsxRuntime = require("react/jsx-runtime");
var Http$ReactHooksTemplate = require("../common/http.res.js");
var Logic$ReactHooksTemplate = require("./Logic.res.js");
var Utils$ReactHooksTemplate = require("../common/utils.res.js");
var Action$ReactHooksTemplate = require("./Action.res.js");
var Survey$ReactHooksTemplate = require("./survey.res.js");
var Campaign$ReactHooksTemplate = require("./campaign.res.js");
var FormField$ReactHooksTemplate = require("../common/FormField.res.js");
var AlertComponent$ReactHooksTemplate = require("../common/AlertComponent.res.js");
var LogicCondition$ReactHooksTemplate = require("./LogicCondition.res.js");
var RedirectionLogic$ReactHooksTemplate = require("./RedirectionLogic.res.js");

var emptyState_survey = Survey$ReactHooksTemplate.empty();

var emptyState_redirectionDelay = {
  TAG: "Valid",
  _0: 500
};

var emptyState_redirectionDelayUnit = {
  TAG: "Valid",
  _0: "ms"
};

var emptyState_redirectionType = {
  TAG: "Valid",
  _0: "automatic"
};

var emptyState_redirectionButtonText = {
  TAG: "Valid",
  _0: ""
};

var emptyState_redirectionDescription = {
  TAG: "Valid",
  _0: ""
};

var emptyState = {
  survey: emptyState_survey,
  redirectionLogics: /* [] */0,
  deletedRedirectionLogics: /* [] */0,
  redirectionDelay: emptyState_redirectionDelay,
  redirectionDelayUnit: emptyState_redirectionDelayUnit,
  redirectionType: emptyState_redirectionType,
  redirectionButtonText: emptyState_redirectionButtonText,
  redirectionDescription: emptyState_redirectionDescription,
  edited: false,
  notification: undefined
};

function RedirectionLogicPage(props) {
  var campaignId = props.campaignId;
  var match = React.useState(function (param) {
        return emptyState;
      });
  var setState = match[1];
  var state = match[0];
  var fetchCampaign = function (survey) {
    var partial_arg = Survey$ReactHooksTemplate.ticketCategories(survey);
    var partial_arg$1 = Survey$ReactHooksTemplate.redirectionUrls(survey);
    var partial_arg$2 = Survey$ReactHooksTemplate.id(survey);
    var partial_arg$3 = Survey$ReactHooksTemplate.dataFields(survey);
    var partial_arg$4 = Survey$ReactHooksTemplate.thankYouList(survey);
    var partial_arg$5 = Survey$ReactHooksTemplate.welcome(survey);
    var partial_arg$6 = Survey$ReactHooksTemplate.questions(survey);
    var partial_arg$7 = function (param) {
      return Logic$ReactHooksTemplate.decode(partial_arg$6, partial_arg$5, partial_arg$4, partial_arg$3, partial_arg$2, partial_arg$1, partial_arg, param);
    };
    var partial_arg$8 = function (param) {
      return Json_decode.list(partial_arg$7, param);
    };
    return Http$ReactHooksTemplate.fetchGetJSONDecode("/api/v1/campaigns/" + campaignId + "/redirection_logics", (function (param) {
                  return Json_decode.field("logics", partial_arg$8, param);
                }));
  };
  React.useEffect((function (param) {
          Js_promise.then_((function (campaign) {
                  return Js_promise.then_((function (json) {
                                var survey = Json_decode.field("survey", Survey$ReactHooksTemplate.fromJson, json);
                                var redirectionDelay = Campaign$ReactHooksTemplate.redirectionDelay(campaign);
                                var match = redirectionDelay >= 1000 ? [
                                    redirectionDelay / 1000 | 0,
                                    "s"
                                  ] : [
                                    redirectionDelay,
                                    "ms"
                                  ];
                                var delayUnit = match[1];
                                var delay = match[0];
                                Curry._1(setState, (function (state) {
                                        return {
                                                survey: survey,
                                                redirectionLogics: state.redirectionLogics,
                                                deletedRedirectionLogics: state.deletedRedirectionLogics,
                                                redirectionDelay: {
                                                  TAG: "Valid",
                                                  _0: delay
                                                },
                                                redirectionDelayUnit: {
                                                  TAG: "Valid",
                                                  _0: delayUnit
                                                },
                                                redirectionType: {
                                                  TAG: "Valid",
                                                  _0: Campaign$ReactHooksTemplate.redirectionType(campaign)
                                                },
                                                redirectionButtonText: {
                                                  TAG: "Valid",
                                                  _0: Belt_Option.getWithDefault(Campaign$ReactHooksTemplate.redirectionButtonText(campaign), "")
                                                },
                                                redirectionDescription: {
                                                  TAG: "Valid",
                                                  _0: Belt_Option.getWithDefault(Campaign$ReactHooksTemplate.redirectionDescription(campaign), "")
                                                },
                                                edited: state.edited,
                                                notification: state.notification
                                              };
                                      }));
                                return Js_promise.then_((function (logics) {
                                              Curry._1(setState, (function (state) {
                                                      return {
                                                              survey: state.survey,
                                                              redirectionLogics: logics,
                                                              deletedRedirectionLogics: state.deletedRedirectionLogics,
                                                              redirectionDelay: state.redirectionDelay,
                                                              redirectionDelayUnit: state.redirectionDelayUnit,
                                                              redirectionType: state.redirectionType,
                                                              redirectionButtonText: state.redirectionButtonText,
                                                              redirectionDescription: state.redirectionDescription,
                                                              edited: state.edited,
                                                              notification: state.notification
                                                            };
                                                    }));
                                              return Promise.resolve();
                                            }), fetchCampaign(survey));
                              }), Http$ReactHooksTemplate.fetchGetJSON("/api/v1/surveys/" + String(Campaign$ReactHooksTemplate.surveyId(campaign))));
                }), Http$ReactHooksTemplate.fetchGetJSONDecode("/api/v1/campaigns/" + campaignId, (function (param) {
                      return Json_decode.field("campaign", Campaign$ReactHooksTemplate.decode, param);
                    })));
        }), []);
  var emptyLogic = function (surveyId, priority, question, redirectionUrls) {
    return Logic$ReactHooksTemplate.make({
                TAG: "Survey",
                _0: surveyId
              }, "Redirection", {
                hd: LogicCondition$ReactHooksTemplate.emptyCondition(undefined, undefined, {
                      TAG: "Question",
                      _0: question
                    }),
                tl: /* [] */0
              }, priority, {
                hd: Action$ReactHooksTemplate.emptyRedirectionAction(Belt_List.head(redirectionUrls)),
                tl: /* [] */0
              });
  };
  var createRedirectionLogic = function (param) {
    var id = Survey$ReactHooksTemplate.id(state.survey);
    if (id === undefined) {
      return ;
    }
    var logicListCount = List.length(Belt_List.keep(state.redirectionLogics, (function (x) {
                return Logic$ReactHooksTemplate.category(x) === "Redirection";
              })));
    var newPriority = logicListCount + 1 | 0;
    var firstQuestion = List.hd(state.survey.questions);
    var logic = emptyLogic(id, newPriority, firstQuestion, state.survey.redirectionUrls);
    var updatedLogics = List.append(state.redirectionLogics, {
          hd: logic,
          tl: /* [] */0
        });
    Curry._1(setState, (function (state) {
            return {
                    survey: state.survey,
                    redirectionLogics: updatedLogics,
                    deletedRedirectionLogics: state.deletedRedirectionLogics,
                    redirectionDelay: state.redirectionDelay,
                    redirectionDelayUnit: state.redirectionDelayUnit,
                    redirectionType: state.redirectionType,
                    redirectionButtonText: state.redirectionButtonText,
                    redirectionDescription: state.redirectionDescription,
                    edited: true,
                    notification: state.notification
                  };
          }));
  };
  var removeRedirectionLogics = function (logic) {
    var updatedLogic = Belt_List.keep(state.redirectionLogics, (function (x) {
            return Caml_obj.notequal(x, logic);
          }));
    var updatedDeletedLogics = Belt_List.add(state.deletedRedirectionLogics, logic);
    Curry._1(setState, (function (state) {
            return {
                    survey: state.survey,
                    redirectionLogics: updatedLogic,
                    deletedRedirectionLogics: updatedDeletedLogics,
                    redirectionDelay: state.redirectionDelay,
                    redirectionDelayUnit: state.redirectionDelayUnit,
                    redirectionType: state.redirectionType,
                    redirectionButtonText: state.redirectionButtonText,
                    redirectionDescription: state.redirectionDescription,
                    edited: true,
                    notification: state.notification
                  };
          }));
  };
  var handleDelayInputChange = function ($$event) {
    var value = Belt_Int.fromString(Utils$ReactHooksTemplate.formTargetValue($$event));
    if (value === undefined) {
      return ;
    }
    var currentUnit = FormField$ReactHooksTemplate.getInputValue(state.redirectionDelayUnit);
    var isValid;
    switch (currentUnit) {
      case "ms" :
          isValid = value >= 100 && value <= 900 && value % 100 === 0;
          break;
      default:
        isValid = value >= 1 && value <= 10;
    }
    if (isValid) {
      return Curry._1(setState, (function (state) {
                    return {
                            survey: state.survey,
                            redirectionLogics: state.redirectionLogics,
                            deletedRedirectionLogics: state.deletedRedirectionLogics,
                            redirectionDelay: {
                              TAG: "Valid",
                              _0: value
                            },
                            redirectionDelayUnit: state.redirectionDelayUnit,
                            redirectionType: state.redirectionType,
                            redirectionButtonText: state.redirectionButtonText,
                            redirectionDescription: state.redirectionDescription,
                            edited: true,
                            notification: state.notification
                          };
                  }));
    }
    
  };
  var updateRedirectionLogic = function (index, newLogic) {
    var updatedLogic = List.mapi((function (i, logic) {
            if (i === index) {
              return newLogic;
            } else {
              return logic;
            }
          }), state.redirectionLogics);
    Curry._1(setState, (function (state) {
            return {
                    survey: state.survey,
                    redirectionLogics: updatedLogic,
                    deletedRedirectionLogics: state.deletedRedirectionLogics,
                    redirectionDelay: state.redirectionDelay,
                    redirectionDelayUnit: state.redirectionDelayUnit,
                    redirectionType: state.redirectionType,
                    redirectionButtonText: state.redirectionButtonText,
                    redirectionDescription: state.redirectionDescription,
                    edited: true,
                    notification: state.notification
                  };
          }));
  };
  var handleDelayUnitChange = function ($$event) {
    var unit = Utils$ReactHooksTemplate.formTargetValue($$event);
    var defaultDelay;
    switch (unit) {
      case "ms" :
          defaultDelay = 500;
          break;
      default:
        defaultDelay = 5;
    }
    Curry._1(setState, (function (state) {
            return {
                    survey: state.survey,
                    redirectionLogics: state.redirectionLogics,
                    deletedRedirectionLogics: state.deletedRedirectionLogics,
                    redirectionDelay: {
                      TAG: "Valid",
                      _0: defaultDelay
                    },
                    redirectionDelayUnit: {
                      TAG: "Valid",
                      _0: unit
                    },
                    redirectionType: state.redirectionType,
                    redirectionButtonText: state.redirectionButtonText,
                    redirectionDescription: state.redirectionDescription,
                    edited: true,
                    notification: state.notification
                  };
          }));
  };
  var handleRedirectionTypeChange = function ($$event) {
    var value = Utils$ReactHooksTemplate.formTargetValue($$event);
    Curry._1(setState, (function (state) {
            return {
                    survey: state.survey,
                    redirectionLogics: state.redirectionLogics,
                    deletedRedirectionLogics: state.deletedRedirectionLogics,
                    redirectionDelay: state.redirectionDelay,
                    redirectionDelayUnit: state.redirectionDelayUnit,
                    redirectionType: {
                      TAG: "Valid",
                      _0: value
                    },
                    redirectionButtonText: state.redirectionButtonText,
                    redirectionDescription: state.redirectionDescription,
                    edited: true,
                    notification: state.notification
                  };
          }));
  };
  var handleRedirectionButtonTextChange = function ($$event) {
    var value = Utils$ReactHooksTemplate.formTargetValue($$event);
    Curry._1(setState, (function (state) {
            return {
                    survey: state.survey,
                    redirectionLogics: state.redirectionLogics,
                    deletedRedirectionLogics: state.deletedRedirectionLogics,
                    redirectionDelay: state.redirectionDelay,
                    redirectionDelayUnit: state.redirectionDelayUnit,
                    redirectionType: state.redirectionType,
                    redirectionButtonText: {
                      TAG: "Valid",
                      _0: value
                    },
                    redirectionDescription: state.redirectionDescription,
                    edited: true,
                    notification: state.notification
                  };
          }));
  };
  var handleRedirectionDescriptionChange = function ($$event) {
    var value = Utils$ReactHooksTemplate.formTargetValue($$event);
    Curry._1(setState, (function (state) {
            return {
                    survey: state.survey,
                    redirectionLogics: state.redirectionLogics,
                    deletedRedirectionLogics: state.deletedRedirectionLogics,
                    redirectionDelay: state.redirectionDelay,
                    redirectionDelayUnit: state.redirectionDelayUnit,
                    redirectionType: state.redirectionType,
                    redirectionButtonText: state.redirectionButtonText,
                    redirectionDescription: {
                      TAG: "Valid",
                      _0: value
                    },
                    edited: true,
                    notification: state.notification
                  };
          }));
  };
  var delayInMilliseconds = function (state) {
    var delay = FormField$ReactHooksTemplate.getInputValue(state.redirectionDelay);
    if (FormField$ReactHooksTemplate.getInputValue(state.redirectionDelayUnit) === "ms") {
      return delay;
    } else {
      return Math.imul(delay, 1000);
    }
  };
  var saveRedirectionLogics = function (param) {
    var logicsAttributes = Belt_List.toArray(Belt_List.concat(Belt_List.map(state.redirectionLogics, (function (x) {
                    return Logic$ReactHooksTemplate.toJson(undefined, x);
                  })), Belt_List.map(state.deletedRedirectionLogics, (function (x) {
                    return Logic$ReactHooksTemplate.toJson(true, x);
                  }))));
    var params = Json_encode.object_({
          hd: [
            "campaign",
            Json_encode.object_({
                  hd: [
                    "logics_attributes",
                    logicsAttributes
                  ],
                  tl: {
                    hd: [
                      "redirection_type",
                      FormField$ReactHooksTemplate.getInputValue(state.redirectionType)
                    ],
                    tl: {
                      hd: [
                        "redirection_button_text",
                        FormField$ReactHooksTemplate.getInputValue(state.redirectionButtonText)
                      ],
                      tl: {
                        hd: [
                          "redirection_description",
                          FormField$ReactHooksTemplate.getInputValue(state.redirectionDescription)
                        ],
                        tl: {
                          hd: [
                            "redirection_delay",
                            delayInMilliseconds(state)
                          ],
                          tl: /* [] */0
                        }
                      }
                    }
                  }
                })
          ],
          tl: /* [] */0
        });
    Js_promise.then_((function (response) {
            var status = Json_decode.field("status", Json_decode.string, response);
            if (status === "success") {
              Js_promise.then_((function (logics) {
                      Curry._1(setState, (function (state) {
                              return {
                                      survey: state.survey,
                                      redirectionLogics: logics,
                                      deletedRedirectionLogics: /* [] */0,
                                      redirectionDelay: state.redirectionDelay,
                                      redirectionDelayUnit: state.redirectionDelayUnit,
                                      redirectionType: state.redirectionType,
                                      redirectionButtonText: state.redirectionButtonText,
                                      redirectionDescription: state.redirectionDescription,
                                      edited: false,
                                      notification: {
                                        TAG: "Success",
                                        _0: "Updated redirection logics successfully"
                                      }
                                    };
                            }));
                      return Promise.resolve();
                    }), fetchCampaign(state.survey));
            } else {
              console.log("Failed to save redirection logics");
              Curry._1(setState, (function (state) {
                      return {
                              survey: state.survey,
                              redirectionLogics: state.redirectionLogics,
                              deletedRedirectionLogics: state.deletedRedirectionLogics,
                              redirectionDelay: state.redirectionDelay,
                              redirectionDelayUnit: state.redirectionDelayUnit,
                              redirectionType: state.redirectionType,
                              redirectionButtonText: state.redirectionButtonText,
                              redirectionDescription: state.redirectionDescription,
                              edited: state.edited,
                              notification: {
                                TAG: "Failure",
                                _0: "failed to update redirection logics"
                              }
                            };
                    }));
            }
            return Promise.resolve();
          }), Http$ReactHooksTemplate.fetchPostEncodedJSON("/api/v1/campaigns/" + campaignId + "/redirection_logics/bulk_update", params));
  };
  var alertType = state.notification;
  return JsxRuntime.jsxs("div", {
              children: [
                alertType !== undefined ? JsxRuntime.jsx("div", {
                        children: JsxRuntime.jsx("div", {
                              children: JsxRuntime.jsx(AlertComponent$ReactHooksTemplate.make, {
                                    alertType: alertType,
                                    handleClose: (function (param) {
                                        Curry._1(setState, (function (state) {
                                                return {
                                                        survey: state.survey,
                                                        redirectionLogics: state.redirectionLogics,
                                                        deletedRedirectionLogics: state.deletedRedirectionLogics,
                                                        redirectionDelay: state.redirectionDelay,
                                                        redirectionDelayUnit: state.redirectionDelayUnit,
                                                        redirectionType: state.redirectionType,
                                                        redirectionButtonText: state.redirectionButtonText,
                                                        redirectionDescription: state.redirectionDescription,
                                                        edited: state.edited,
                                                        notification: undefined
                                                      };
                                              }));
                                      })
                                  }),
                              className: "max-w-7xl mx-auto px-6 sm:px-8 py-4"
                            }),
                        className: "fixed top-0 left-0 right-0 z-50"
                      }) : null,
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsx(RedirectionLogic$ReactHooksTemplate.make, {
                            survey: state.survey,
                            redirectionLogics: state.redirectionLogics,
                            updateRedirectionLogic: updateRedirectionLogic,
                            removeRedirectionLogics: removeRedirectionLogics,
                            createRedirectionLogic: createRedirectionLogic,
                            redirectionDelay: state.redirectionDelay,
                            redirectionDelayUnit: state.redirectionDelayUnit,
                            onRedirectionDelayChange: handleDelayInputChange,
                            onRedirectionDelayUnitChange: handleDelayUnitChange,
                            redirectionType: state.redirectionType,
                            onRedirectionTypeChange: handleRedirectionTypeChange,
                            redirectionButtonText: state.redirectionButtonText,
                            onRedirectionButtonTextChange: handleRedirectionButtonTextChange,
                            redirectionDescription: state.redirectionDescription,
                            onRedirectionDescriptionChange: handleRedirectionDescriptionChange,
                            edited: state.edited,
                            saveRedirectionLogics: saveRedirectionLogics
                          }),
                      className: "p-10"
                    })
              ]
            });
}

var make = RedirectionLogicPage;

exports.emptyState = emptyState;
exports.make = make;
/* emptyState Not a pure module */
